import React, { Suspense } from 'react';
import { Router, Switch, Route } from 'react-router-dom';

import Error404 from 'pages/error-404';

import history from './history';
import { ProtectedRoute } from './protected-route';
import {
  authRoutes,
  userRoutes,
  profileRoutes,
  circulationRoutes,
  historyRoutes,
  customerRoutes,
  communicationRoutes,
  helpInfoRoutes,
  adminRoutes,
} from './routes';

const AppRouter: React.FC = () => {
  return (
    <Router history={history}>
      <Suspense fallback={<div />}>
        <Switch>
          {/* Public Routes */}
          {authRoutes.map(({ path, component: Component, exact }) => (
            <Route key={path} path={path} exact={exact} component={Component} />
          ))}

          {/* Protected Routes */}
          {[
            ...userRoutes,
            ...profileRoutes,
            ...circulationRoutes,
            ...historyRoutes,
            ...customerRoutes,
            ...communicationRoutes,
            ...helpInfoRoutes,
            ...adminRoutes,
          ].map(({ path, component, exact }) => (
            <ProtectedRoute key={path} path={path} exact={exact} component={component} />
          ))}

          {/* 404 Route */}
          <ProtectedRoute component={Error404} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
